// extracted by mini-css-extract-plugin
module.exports = {"group":"SRsGFz0J","title":"FtQexmhC","list":"JX2h9m6I","orgs":"__54JBnhCY","self":"Y0lvqxy5","active":"qa84uy30","action":"B39jWUBY","checked":"ZPAwnBu2","text":"hL_ZcRFY"};